import usePlans from 'lib/hooks/usePlans';
import {
  Card,
  Heading,
  IconList,
  LinkWithButtonStyles,
} from '@frontendmentorio/design-system-v2';

import MonthlyPrice from './MonthlyPrice';
import PurchaseButton from './PurchaseButton';
import YearlyPrice from './YearlyPrice';

function Included({ children, className }) {
  return (
    <IconList.Item
      icon={{
        className: 'text-lg text-blue-500',
        name: 'circle-check',
        style: 'solid',
      }}
    >
      <span className={className}>{children}</span>{' '}
      <span className="sr-only">(included)</span>
    </IconList.Item>
  );
}

export default function Individuals({ withCheckout }) {
  const { monthly, yearly } = usePlans();

  return (
    <div className="flex flex-col gap-5 max-w-[24rem] w-full tablet:container-md tablet:flex-row">
      <Card className="flex flex-col gap-5 items-center px-5 py-6">
        <span className="font-secondary text-lg">Monthly</span>
        <MonthlyPrice />

        {withCheckout ? (
          <PurchaseButton plan={monthly} />
        ) : (
          <LinkWithButtonStyles className="w-full" href="/pro">
            Learn more
          </LinkWithButtonStyles>
        )}

        <IconList className="self-start">
          <Included>Free challenges</Included>
          <Included className="font-bold">AI-powered solution feedback</Included>
          <Included className="font-bold">5 Figma design files/month</Included>
          <Included className="font-bold">2 premium challenges/month</Included>
          <Included>Unlimited solution screenshots</Included>
          <Included>Private solutions</Included>
          <Included>Custom solution domains</Included>
          <Included>View challenges solutions early</Included>
        </IconList>
      </Card>

      <Card className="border-blue-500 border-2 flex flex-col gap-5 items-center px-5 py-6 rounded-tl-none rounded-tr-none relative mt-[2rem] overflow-visible tablet:mt-0">
        <div className="absolute bg-blue-500 left-[-2px] bottom-full py-[0.5rem] rounded-tr-2xl rounded-tl-2xl text-white w-[calc(100%+4px)]">
          <Heading
            className="block font-secondary italic text-sm tracking-wider text-center"
            level="2"
            tagName="span"
          >
            Best value
          </Heading>
        </div>

        <span className="font-secondary text-lg">Yearly</span>
        <YearlyPrice />

        {withCheckout ? (
          <PurchaseButton plan={yearly} />
        ) : (
          <LinkWithButtonStyles className="w-full" href="/pro">
            Learn more
          </LinkWithButtonStyles>
        )}

        <IconList className="self-start">
          <Included>Free challenges</Included>
          <Included className="font-bold">AI-powered solution feedback</Included>
          <Included className="font-bold">
            Unlimited Figma design files
          </Included>
          <Included className="font-bold">
            Unlimited premium challenges
          </Included>
          <Included>Unlimited solution screenshots</Included>
          <Included>Private solutions</Included>
          <Included>Custom solution domains</Included>
          <Included>View challenges solutions early</Included>
        </IconList>
      </Card>
    </div>
  );
}
